import { ControlError } from '../../../lib/util/ValidationSchemes/ValidationTypes';

export type SignUpForm = {
  country: string;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
};

export type SignUpFormWithPolicies = SignUpForm & {
  isPrivacyPolicyApproved: boolean;
  isTournamentPolicyApproved: boolean;
  steps:{
    isPersonalInfoPassed:boolean;
    isAuthInfoPassed:boolean;
    isVerifyEmailPassed:boolean;
    isVerifyPhonePassed:boolean;
    isSetupUserNamePassed:boolean;
  }
};

export type SignUpFormErrors = {
  country: ControlError[];
  firstName: ControlError[];
  lastName: ControlError[];
  email: ControlError[];
  privacyPolicyError: string;
};

export type SignUpFormWithPoliciesErrors = SignUpFormErrors & {
  tournamentPolicyError: string;
};

export const DefaultSignUpFormValue: SignUpForm = {
  country: '',
  firstName: '',
  lastName: '',
  email: '',
  password: '',
};

export const SignUpFormWithPoliciesValue: SignUpFormWithPolicies = {
  country: 'BG',
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  isPrivacyPolicyApproved: false,
  isTournamentPolicyApproved: false,
  steps: {
    isPersonalInfoPassed: false,
    isAuthInfoPassed: false,
    isVerifyEmailPassed: false,
    isVerifyPhonePassed: false,
    isSetupUserNamePassed: false,
  },

};

export const DefaultSignUpFormErrors: SignUpFormErrors = {
  country: [],
  firstName: [],
  lastName: [],
  email: [],
  privacyPolicyError: '',
};

export const DefaultSignUpFormWithPoliciesErrors: SignUpFormWithPoliciesErrors = {
  country: [],
  firstName: [],
  lastName: [],
  email: [],
  privacyPolicyError: '',
  tournamentPolicyError: '',
};
